// src/pages/MasterAdminDashboard.js
import React from 'react';
import DashboardShell from '../components/dashboard/DashboardShell';
import MasterAdminDashboardView from '../components/dashboard/masteradmin/MasterAdminDashboardView';
import { getUser } from '../utils/auth';

function MasterAdminDashboard() {
  const user = getUser();

  return (
    <DashboardShell title={`Welcome, ${user.name}`} subtitle="Organization-wide overview">
      <MasterAdminDashboardView />
    </DashboardShell>
  );
}

export default MasterAdminDashboard;
